import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/GeneralDonate.css';
import environment from '../config/environment';
import { causes } from '../data/causes'; // Import local causes data as fallback

const GeneralDonate = () => {
  const { apiUrl } = environment();  // Get apiUrl directly
  const [causesData, setCauses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCauses = async () => {
      try {
        setLoading(true);
        console.log('Fetching from:', apiUrl);
        if (!apiUrl) {
          throw new Error('API URL is undefined');
        }

       const response = await fetch(`${apiUrl}/api/causes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (data.status === 'success' && data.data.causes) {
          setCauses(data.data.causes);
        } else {
          // If API fails, use local data
          console.log('Using local causes data');
          setCauses(causes);
        }
      } catch (error) {
        console.error('Fetch error:', error);
        // On error, fall back to local data
        console.log('Falling back to local causes data');
        setCauses(causes);
      } finally {
        setLoading(false);
      }
    };

    fetchCauses();
  }, []);

  const handleCauseSelect = (causeId) => {
    if (!causeId) return;
    console.log('Selected cause ID:', causeId);
    navigate(`/donate/${causeId}`);
  };

  if (loading) {
    return (
      <div className="donate-wrapper">
        <div className="donate-container">
          <div className="loading-state">Loading causes...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="donate-wrapper">
        <div className="donate-container">
          <div className="error-state">
            {error}
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="donate-wrapper">
      <div className="donate-container">
        <div className="donate-header">
          <h1>Support Our Causes</h1>
          <p>Choose where to direct your support</p>
        </div>

        <div className="cause-selector-section">
          <div className="cause-selector-wrapper">
            <select
              className="cause-selector"
              onChange={(e) => handleCauseSelect(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>Select a cause to support</option>
              {causesData.map(cause => (
                <option 
                  key={cause._id} 
                  value={cause._id}
                >
                  {cause.name}
                </option>
              ))}
            </select>
          </div>
          <div className="cause-description">
            <p>Select a specific cause to support or make a general donation to help all our initiatives.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralDonate; 